import { useTranslation } from "react-i18next"
import "./StockIndicator.scss"

interface StockIndicatorProps {
    stock: number | null
}

const StockIndicator: React.FC<StockIndicatorProps> = ({ stock }: StockIndicatorProps) => {
    const { t } = useTranslation();

    const getTitle = (stock: number | null) => {
        if (stock === null || stock <= 0) {
            return (t("productPriceAvail.outOfStock"));
        } else if (stock > 0 && stock <= 5) {
            return (t("productPriceAvail.stocksScarce"));
        } else {
            return (t("productPriceAvail.available"));
        }
    }

    const getBars = (stock: number | null) => {
        if (stock === null || stock <= 0) {
            return (
                <>
                    <div className="stockIndicatorBar stockIndicatorBar-danger"></div>
                    <div className="stockIndicatorBar"></div>
                    <div className="stockIndicatorBar"></div>
                </>
            );
        } else if (stock > 0 && stock <= 5) {
            return (
                <>
                    <div className="stockIndicatorBar stockIndicatorBar-warning"></div>
                    <div className="stockIndicatorBar stockIndicatorBar-warning"></div>
                    <div className="stockIndicatorBar"></div>
                </>
            );
        } else {
            return (
                <>
                    <div className="stockIndicatorBar stockIndicatorBar-success"></div>
                    <div className="stockIndicatorBar stockIndicatorBar-success"></div>
                    <div className="stockIndicatorBar stockIndicatorBar-success"></div>
                </>
            );
        }
    }

    return (
        <div className="stockIndicator" title={getTitle(stock)}>
            {getBars(stock)}
        </div>
    )
}

export default StockIndicator;